import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, ButtonBase, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

const useStyles = makeStyles((theme) => ({
  filterButtonBtn: {
    border: 'none',
    background: 'none',
    fontWeight: 'bold',
    cursor: 'pointer',
    color: theme.palette.grey[500],
    borderRadius: 25,
  },
  filterButtonActive: {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.grey[200],
  },
  dateField: {
    display: 'flex',
    justifyContent: 'space-around',
    alignContent: 'center',
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
  custom: {
    margin: '8px',
  },
}));

const TimeFrameButtons = ({
  timeFrames,
  currentTimeFrame,
  onChange,
  showFields,
  customOnChange,
}) => {
  const [dateValues, setDateValues] = useState({
    startDate: '',
    endDate: '',
  });
  const { t } = useTranslation(
    'App.Dashboard.Participant.AccountBalance.TimeFrameButtons'
  );
  const classes = useStyles();

  if (timeFrames.length <= 1) {
    return null;
  }

  const onClick = (value) => {
    if (onChange) {
      onChange(value);
    }
  };
  const customDateOnChange = (event) => {
    const { name, value } = event.target;
    setDateValues({ ...dateValues, [name]: value });
  };

  const customOnClick = () => {
    if (customOnChange) {
      customOnChange('Custom', dateValues.startDate, dateValues.endDate);
    }
  };
  return (
    <Box>
      <Box display="flex" justifyContent="center">
        {timeFrames.map((x) => (
          <Box key={x.label} pt={2} mx={0.5}>
            <ButtonBase
              className={classnames(classes.filterButtonBtn, {
                [classes.filterButtonActive]: currentTimeFrame === x.label,
              })}
              type="button"
              onClick={() => onClick(x.label)}
            >
              <Box p={1}>{t(x.label)}</Box>
            </ButtonBase>
          </Box>
        ))}
      </Box>
      {showFields && (
        <Box className={classes.dateField}>
          <TextField
            className={classes.custom}
            fullWidth={false}
            InputLabelProps={{ shrink: true }}
            label="Start Date"
            type="date"
            name="startDate"
            onChange={customDateOnChange}
          />
          <TextField
            className={classes.custom}
            fullWidth={false}
            InputLabelProps={{ shrink: true }}
            type="date"
            name="endDate"
            label="End Date"
            onChange={customDateOnChange}
          />
          <Box display="flex" alignContent="center" className={classes.custom}>
            <Button onClick={customOnClick}>Enter</Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};

TimeFrameButtons.propTypes = {
  timeFrames: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      date: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    })
  ).isRequired,
  currentTimeFrame: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  showFields: PropTypes.bool,
  customOnChange: PropTypes.func,
};

export default TimeFrameButtons;
